export const photoCollections = [
  {
    id: 'p1',
    title: '柔光主题写真',
    category: '色调',
    period: '本季',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20elegant%20photobook%20cover%20artwork%20with%20soft%20cream%20and%20dusty%20rose%20gradient%2C%20delicate%20paper%20grain%20texture%2C%20minimal%20overlapping%20geometric%20shapes%2C%20warm%20golden%20rim%20light%2C%20refined%20editorial%20design%20with%20no%20text%2C%20calm%20sophisticated%20mood%2C%20harmonious%20composition%2C%20high%20detail&width=800&height=1000&seq=mikami-photo-01&orientation=portrait',
    alt: '柔光主题写真合集封面示意图，暖米色与玫瑰色调的抽象概念图',
    note: '以柔光与低对比为主的写真合集，色调统一，适合作为风格入门参考。',
  },
  {
    id: 'p2',
    title: '暖调外景写真',
    category: '外景',
    period: '近年',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20artistic%20poster%20with%20warm%20terracotta%20and%20sand%20color%20blocks%2C%20soft%20shadow%20gradients%2C%20minimal%20linear%20composition%2C%20subtle%20film%20grain%2C%20refined%20gallery%20aesthetic%20without%20any%20text%2C%20cozy%20muted%20tones%2C%20balanced%20negative%20space%2C%20high%20detail&width=800&height=1000&seq=mikami-photo-02&orientation=portrait',
    alt: '暖调外景写真合集封面示意图，陶土色与沙色的抽象概念图',
    note: '以外景与自然光为主，色调偏暖，画面松弛，信息以地点与季节为主。',
  },
  {
    id: 'p3',
    title: '金调质感写真',
    category: '质感',
    period: '近年',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20artwork%20in%20muted%20gold%20and%20ivory%20tones%2C%20layered%20translucent%20shapes%2C%20gentle%20diagonal%20light%20streaks%2C%20fine%20textile%20texture%2C%20elegant%20contemporary%20design%20with%20no%20lettering%2C%20serene%20luxurious%20atmosphere%2C%20high%20detail&width=800&height=1000&seq=mikami-photo-03&orientation=portrait',
    alt: '金调质感写真合集封面示意图，金色与象牙色的抽象概念图',
    note: '强调材质与质感的写真合集，细节丰富，适合关注画面细节的读者。',
  },
  {
    id: 'p4',
    title: '暗调氛围写真',
    category: '氛围',
    period: '阶段性',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20moody%20composition%20with%20deep%20warm%20brown%20and%20rose%20gradients%2C%20soft%20glowing%20highlights%2C%20organic%20blurred%20forms%2C%20subtle%20noise%20texture%2C%20artistic%20editorial%20style%20without%20text%2C%20intimate%20atmospheric%20feeling%2C%20high%20detail&width=800&height=1000&seq=mikami-photo-04&orientation=portrait',
    alt: '暗调氛围写真合集封面示意图，深棕与玫瑰色的抽象概念图',
    note: '暗调与高反差为主的写真合集，氛围感强，适合喜欢叙事感的浏览。',
  },
];